.wrapper {
	composes: wrapper from "../base-input/base-input.module.css";
}

.invalidField {
	composes: invalidField from "../base-input/base-input.module.css";
}

.group {
	display: flex;
	align-items: center;
	background-color: var(--elevation-default);
	border: solid 1px var(--border-primary);
	border-radius: 8px;
	padding: 8px 12px;
	gap: 8px;
	color: var(--content-primary);
}

.group[data-hovered]:not([data-focus-within]) {
	border: solid 1px var(--border-hover);
}

.group[data-focus-within] {
	outline: var(--focus-outline);
}

.invalidField .group {
	border: solid 1px var(--border-error);
	color: var(--content-error);
}

.invalidField .group[data-hovered]:not([data-focus-within]) {
	border: solid 1px var(--border-error);
}

.input {
	display: flex;
	flex: 1;
	min-width: 0;
}

.segment {
	color: var(--content-primary);
	outline: none;
	border-radius: 4px;
	letter-spacing: 0.04em;
}

.segment[data-placeholder] {
	color: var(--content-tertiary);
}

.segment[data-focused] {
	background-color: var(--elevation-medium);
	color: var(--content-primary);
}

.invalidField .segment {
	color: var(--content-error);
}

.invalidField .segment[data-placeholder] {
	color: var(--content-error);
}

.triggerButton {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 16px;
	height: 16px;
	color: var(--content-tertiary);
	background: transparent;
	border: none;
	padding: 0;
	cursor: pointer;
}

.triggerButton svg {
	pointer-events: none;
}

.triggerButton[data-hovered] {
	color: var(--content-primary);
}

.triggerButton[data-focus-visible] {
	outline: var(--focus-outline);
	border-radius: 4px;
}

.popover {
	background-color: var(--elevation-default);
	border: solid 1px var(--border-primary);
	border-radius: 8px;
	box-shadow: var(--box-shadow);
	outline: none;
}

.dialog {
	padding: 12px;
	outline: none;
}

.calendar {
	display: flex;
	flex-direction: column;
	gap: 8px;
	color: var(--content-primary);
}

.calendarHeader {
	display: flex;
	align-items: center;
	gap: 4px;
	padding: 0 4px;
}

.calendarHeading {
	flex-grow: 1;
	text-align: center;
	margin: 0;
	color: var(--content-primary);
}

.calendarNavButton {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 24px;
	height: 24px;
	border: none;
	background: transparent;
	border-radius: 4px;
	color: var(--content-primary);
	cursor: pointer;
}

.calendarNavButton[data-hovered] {
	background-color: var(--elevation-medium);
	color: var(--content-primary);
}

.calendarNavButton[data-focus-visible] {
	outline: var(--focus-outline);
}

.calendarNavButton[data-disabled] {
	color: var(--content-tertiary);
	cursor: not-allowed;
}

.calendarGrid {
	border-collapse: collapse;
	border-spacing: 0;
}

.calendarHeaderCell {
	width: 32px;
	height: 32px;
	text-align: center;
	color: var(--content-tertiary);
}

.calendarCell {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 32px;
	height: 32px;
	border-radius: 50%;
	cursor: pointer;
	color: var(--content-primary);
	outline: none;
}

.calendarCell[data-outside-month] {
	display: none;
}

.calendarCellToday {
	outline: solid 1px var(--border-primary);
	outline-offset: -1px;
}

.calendarCellToday[data-focus-visible] {
	outline: var(--focus-outline);
}

.calendarCellToday[data-selected] {
	outline-color: var(--background-secondary);
}

.calendarCell[data-hovered] {
	background-color: var(--elevation-medium);
}

.calendarCell[data-focus-visible] {
	outline: var(--focus-outline);
}

.calendarCell[data-selected] {
	background-color: var(--background-secondary);
	color: var(--content-secondary);
}

.calendarCell[data-disabled],
.calendarCell[data-unavailable] {
	color: var(--content-tertiary);
	cursor: not-allowed;
}

.calendarCell[data-disabled][data-hovered],
.calendarCell[data-unavailable][data-hovered] {
	background-color: transparent;
}
